export enum BuildEnv {
  dev = "dev",
  stag = "stag",
  prod = "prod",
}

export default class GlobalConfig {
  static env = BuildEnv.dev;
  static isDebug = false;

  static get debugging(): boolean {
    if (isServer()) {
      return this.isDebugInServer();
    }
    return this.isDebug;
  }

  static isDebugInServer = () => {
    return (
      process.env.NODE_ENV == "development" || process.env.NODE_ENV == "test"
    );
  };

  static get isDev() {
    return this.env === BuildEnv.dev;
  }
  static get isStag() {
    return this.env === BuildEnv.stag;
  }
  static get isProd() {
    return this.env === BuildEnv.prod;
  }

  static get originUrl(): string {
    const fullUrl = window.location.origin;
    const url = fullUrl;
    return url;
  }

  static get mobileApiUrl(): string {
    switch (this.env) {
      case BuildEnv.dev:
        return "https://api.dev-sg.vioapp.io/api/";
      case BuildEnv.stag:
        return "https://api.staging-sg.vioapp.io/api/";
      case BuildEnv.prod:
        return "https://api.prod-sg.vioapp.io/api/";
    }
  }

  static get chatbotApiUrl(): string {
    switch (this.env) {
      case BuildEnv.dev:
        return "https://n8n.dev-sg.vioapp.io/webhook/";
      case BuildEnv.stag:
        return "https://n8n.prod-sg.vioapp.io/webhook/";
      case BuildEnv.prod:
        return "https://n8n.prod-sg.vioapp.io/webhook/";
    }
  }

  static get currentServerEnv(): BuildEnv {
    return (process.env.ENV as BuildEnv | undefined) ?? BuildEnv.dev;
  }
  static domain({ env }: { env?: BuildEnv } = {}): string {
    if (this.debugging) {
      return "http://192.168.1.10:3000/";
    }
    switch (env ?? this.env) {
      case BuildEnv.dev:
        return "https://dev-miniapp.vioapp.vn/";
      case BuildEnv.stag:
        return "https://staging-miniapp.vioapp.vn/";
      case BuildEnv.prod:
        return "https://miniapp.vioapp.vn/";
    }
  }

  static apiUrl({ env }: { env?: BuildEnv } = {}): string {
    const domain = this.domain({ env });
    return domain + "api/";
  }
}

function isServer(): boolean {
  return typeof window === "undefined";
}
